export interface BlockScheduleModel {
  blockScheduleId: number;
  projectId?: number;
  shipDate?: Date | null;
  tmeicSkidNo?: number;
  name?: string | null;
  blockName?: string | null;
  integratorSkidSerialNo?: string;
  customerSkidNumber?: string;
  skidConfiguration?: string;
  billoflading?: string;
  appointmentTime?: Date| null;
  overWeight?: boolean;
  overDimension?: boolean;
  shippingStatus?: string;
  inv1SerialNo?: string;
  inv2SerialNo?: string;
  inv3SerialNo?: string;
  inv4SerialNo?: string;
  inv5SerialNo?: string;
  inv6SerialNo?: string;
  inv7SerialNo?: string;
  scu?: string;
  dis?: string;
  epanb?: string;
  mvXfmrDesign?: string;
  mvXfmrSerialNo?: string;
  lvXfmrSerialNo?: string;
  bushingSize?: number;
  scadaSerialNo?: string;
  trackerSerialNo1?: string;
  trackerSerialNo2?: string;
  createdBy?: number;
  createdDate?: Date;
  updatedBy?: number;
  updatedDate?: Date;
  arrivalDate?: Date| null;
  notes?: string;
  logisticsComment?: string;
  dcFuses?: string;
  skidStatus?: string | null;
  deliveryDate?: Date| null;
  inv1Igbt?: string;
  inv2Igbt?: string;
  inv3Igbt?: string;
  inv4Igbt?: string;
  inv5Igbt?: string;
  inv6Igbt?: string;
  inv7Igbt?: string;
  wildlifeRepellentAdded?: string;
  wildlifeWarningLabelApplied?: string;
  estimatedDeliveryDate?: Date| null;
  isCustom?: boolean;
}

export interface BlockScheduleResponse {
  blockSchedule: BlockScheduleModel;
  message?: string;
}

export interface BlockScheduleSearchParams {
  projectId?: number;
  tmeicSkidNo?: string;
  skidStatus?: string;
  startDate?: Date;
  endDate?: Date;
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export enum BlockScheduleStatus {
  IN_PROGRESS = 'In-Progress',
  COMPLETE = 'Complete',
  SHIPPED = 'Shipped'
}

export enum ShippingStatus {
  NOT_SHIPPED = 'Not Shipped',
  IN_TRANSIT = 'In Transit',
  DELIVERED = 'Delivered',
  DELAYED = 'Delayed',
  RETURNED = 'Returned'
}

// Inverter IGBT options
export enum InverterIgbtType {
  MITSUBISHI = 'Mitsubishi',
  INFINEON = 'Infineon'
}

// Wildlife Deterrent options
export enum WildlifeDeterrentStatus {
  YES = 'Y',
  NO = 'N',
  NOT_APPLICABLE = 'A'
}

// ViewModel for Block Schedule with computed display properties
export interface BlockScheduleViewModel extends BlockScheduleModel {
  // Computed display properties (prefixed with _ to indicate internal/computed)
  _isCompleted?: boolean;
  _actualSkidStatus?: string | null;
  _inv1Enabled?: boolean;
  _inv2Enabled?: boolean;
  _inv3Enabled?: boolean;
  _inv4Enabled?: boolean;
  _inv5Enabled?: boolean;
  _inv6Enabled?: boolean;
  _inv7Enabled?: boolean;
  _isShipWeekend?: boolean;
  _isArrivalWeekend?: boolean;
  selected?: boolean; // For row selection checkbox
}

export interface BlockScheduleTemplateModel {
  id: number;
  projectId?: number;
  transitDays?: number;
  monShipDay?: Date;
  monArrivalDay?: Date;
  tueShipDay?: Date;
  tueArrivalDay?: Date;
  wedShipDay?: Date;
  wedArrivalDay?: Date;
  thuShipDay?: Date;
  thuArrivalDay?: Date;
  friShipDay?: Date;
  friArrivalDay?: Date;
  monSkids?: number;
  tueSkids?: number;
  wedSkids?: number;
  thuSkids?: number;
  friSkids?: number;
}
